<script setup>
import { ref, watch, computed, getCurrentInstance } from 'vue';

const props = defineProps({
    id: {
        type: Number,
        required: true
    },
    code: {
        type: String,
        default: ''
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const html = ref('');
const ajaxLoader = ref(require('../../../src/img/ajax-loader.gif'));

// --- Computed ---

const alphaMode = computed(() => store.state.alphaMode);

// --- Methods ---

const renderTemplate = async () => {
    // Address the todo: Kill the process if alphaMode is off
    if (!alphaMode.value) {
        html.value = '';
        return;
    }

    try {
        const response = await store.dispatch('request/post', {
            url: 'api/template/render',
            postData: {
                templateId: props.id,
                templateHtml: props.code
            },
            customHeaders: {
                'X-Http-Method-Override': 'GET'
            }
        });

        if (response?.data) {
            /** * Script to disable click events while preserving hover effects.
             * This prevents navigation attempts inside the preview iframe.
             */
            const clickDisableScript = `
                <script>
                    document.addEventListener('click', function(e) {
                        e.preventDefault();
                    }, true);
                <\/script>
            `;

            html.value = clickDisableScript + response.data;
        }
    } catch (error) {
        console.error("Preview render failed:", error);
        html.value = '';
    }
};

// --- Watchers ---

// Re-render when the ID or the code changes
watch(
    () => [props.id, props.code, alphaMode.value],
    () => {
        renderTemplate();
    },
    { immediate: true }
);
</script>

<template>
    <iframe v-if="html" :srcdoc="html"/>
    <div v-else class="themes-editor-preview-pane-ajax-loader-container">
        <img :src="ajaxLoader" alt="" class="themes-editor-preview-pane-ajax-loader">
    </div>
</template>